import React from "react"
import PropTypes from "prop-types"
import ProductFeatureList from "components/Product/FeatureList"

function ProductSliceZone({ ...props }) {
  const { slices, ...rest } = props

  const slice = slices?.map((s, i) => {
    switch (s.type) {
      case "feature_list":
        return (
          <ProductFeatureList
            key={`${s.type}_${i}`}
            features={s.features}
            {...rest}
          />
        )
      default:
        console.warn(`No support for slice type ${s.type}`)
        return null
    }
  })
  return <>{slice}</>
}

ProductSliceZone.propTypes = {
  slices: PropTypes.array.isRequired,
}

export default ProductSliceZone
